import { render } from "./IVkMoney.vue?vue&type=template&id=6520ef12"
import script from "./IVkMoney.vue?vue&type=script&lang=js"
export * from "./IVkMoney.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__